export class SecurityHelper {
    public static createSixDigitLoanId() {
        return Math.random().toString(36).substr(2, 6).toUpperCase()
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/securityHelper.ts